import React from "react";
import { Youtube, Instagram, Gamepad2, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  return <section data-section-id="59438" id="subsol" className="dark py-16 font-sans card shadow-xl data-animate text-primary-100">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://vladcotoros.md/wp-content/uploads/2026/03/logo__Varianta-orizontala-secundara-pe-fundal-inchis-1-scaled.png" alt="WebinarClon Logo" className="object-contain !h-[150px]" />
            </Link>
            <div className="space-y-2">
              <p className="text-sm text-primary-300 leading-relaxed">© 2026 Vlad Cotoros. Toate drepturile rezervate.</p>
              <p className="text-sm text-primary-300 leading-relaxed">MAIN AGENCY - Curs practic de marketing pentru antreprenori care vor să atragă clienți din Instagram, TikTok și Facebook</p>
            </div>
          </div>

          {}
          

          {}
          
        </div>

        <Separator className="bg-primary-900/30 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2 text-xs text-primary-300">
            <span>Elaborat de echipa Main Agency</span>
            <Heart className="h-3 w-3 text-primary-500 fill-primary-500 animate-pulse" />
          </div>

          <div className="flex items-center gap-6">
            <Link to="https://www.instagram.com/vladcotoros/" aria-label="Instagram" className="text-primary-300 hover:text-primary-500 transition-colors">
              <Instagram className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}